<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6">
        <date-picker
          v-model="selectedDate"
          label="조회 날짜"
          hide-details
          outlined></date-picker>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="customFilters.group"
          :items="groups"
          label="노선"
          hide-details
          clearable
          outlined></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="customFilters.plateNo"
          label="차량번호"
          hide-details
          clearable
          outlined></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="customFilters.driver"
          label="운전자"
          hide-details
          clearable
          outlined></v-text-field>
      </v-col>
    </v-row>

    <v-btn color="primary" to="/settings/plans/new">새 배차 작성</v-btn>
    <v-data-table
    :items="items"
    :loading="loading"
    :headers="headers"
    :search="search"
    :custom-filter="customFilter"
    class="text-no-wrap">
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item._id)"><v-icon>mdi-cog</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getPlanList } from '@/api'
import get from 'lodash/get'
export default {
  data () {
    return {
      plans: [],
      customFilters: {
        plateNo: '',
        driver: '',
        group: ''
      },
      selectedDate: this.$moment().format('YYYY-MM-DD'),
      headers: [
        {
          text: '노선',
          value: 'group.name'
        },
        {
          text: '차량번호',
          value: 'plateNo'
        },
        {
          text: '운전자',
          value: 'driver'
        },
        {
          text: '시간',
          value: 'time'
        },
        {
          text: '편집',
          value: 'edit'
        }
      ],
      loading: false
    }
  },
  computed: {
    search () {
      return JSON.stringify(this.customFilters)
    },
    filters () {
      const filters = {
        date: this.selectedDate
      }

      return filters
    },
    query () {
      return {
        populate: 'driver device group',
        sort: '-startDate'
      }
    },
    groups () {
      return Object.entries(
        this.items.reduce((groups, row) => {
          if (!groups[row.group._id]) groups[row.group._id] = row.group.name

          return groups
        }, {})
      )
        .map((_id, name) => {
          return {
            text: name,
            value: _id
          }
        })
    },
    items () {
      return this.plans.map(plan => {
        const group = {
          name: get(plan, 'group.name', '미지정'),
          _id: get(plan, 'group._id', null)
        }
        const plateNo = get(plan, 'device.info.plateNo', '미지정')
        const driver = get(plan, 'driver.name', '미지정')
        const startDate = this.$moment(plan.startDate)
        const date = startDate.format('YYYY-MM-DD')
        const time = startDate.format('HH:mm')

        return {
          _id: plan._id,
          group,
          plateNo,
          driver,
          date,
          time
        }
      })
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler: 'fetchPlans'
    }
  },
  methods: {
    async fetchPlans () {
      this.loading = true
      try {
        const { plans } = await getPlanList(this.filters, this.query)

        this.plans = plans
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    getEditPath (_id) {
      return `/settings/plans/edit/${_id}`
    },
    customFilter (value, search, item) {
      const { plateNo = '', group = '', driver = '' } = JSON.parse(search)

      return value &&
      typeof value === 'string' &&
      (!plateNo || item.plateNo.indexOf(plateNo) !== -1) &&
      (!group || item.group._id === group) &&
      (!driver || item.driver.indexOf(driver) !== -1)
    }
  }
}
</script>
